/**
 * Manage header bar.
 * 
 */

/* global jQuery */

/**
 * The nav menus (desktop and mobile) in the header bar work in
 * conjunction with the WP menu builder.  We render out a separate
 * markup structure for each of the two menus, but both are based
 * on the same 'base' menu layout in WP.  We use custom classes
 * within the WP menu builder in order to customize the look
 * and item visibility within each of the menus.  We also use
 * two separte menu walker classes to render out the markup
 * differently, based on which menu is being built. 
 * 
 * Here is a summary of the classes that can be applied to
 * items within the menu builder to control their appearance,
 * visibility, and functionality:
 *   - menu-header -- (mobile, desktop) used for top-level items that
 *         have child elements, and are not themselves meant to be links
 *   - menu-header-always-open -- (mobile) used for top-level items that
 *         should never be collapsed
 *   - panel-id-* -- (mobile, desktop) used for top-level items which have 
 *         dropdown panels (ie. have child elements), where the panel id
 *         value is used to link to an ACF item (in global menu callouts)
 *         that gets rendered out into the dropdown panel 
 *   - panel-callout-first -- (mobile) used for top-level items to 
 *         indicate that the panel's callout should be rendered out 
 *         BEFORE any of the child link items are rendered.
 *   - menu-section-label -- (mobile, desktop) used for secondary
 *         level items that are meant to group and label a series of
 *         sub-items (where the sub-items are the actual links)
 *   - button-style -- (mobile, desktop) used to style a link to look
 *         like a button. 
 *   - button-style-blue -- (mobile, desktop) styles a link to look
 *         like a blue button.
 *   - hide-desktop -- (mobile) used for items meant to be only seen
 *         on mobile.
 *   - hide-mobile -- (desktop) used for items meant to be only seen
 *         on desktop.
 *   - request-a-demo-link (mobile, desktop) used on items that should
 *         link to 'request a demo' page (may be 3rd party site). There
 *         will be multiple occurances of this link, so the linkage
 *         is externalized to be JS managed, to make updates easier.
 */

const $ = jQuery;   // jQuery loaded via WordPress enqueue process

let $header = null,
	$window = $(window);

function initHeader() {
	// console.log('initHeader()');

	// Init the menu elements within the header
	if (!window.matchMedia('(pointer:coarse)').matches) {
		// Only init desktop menu (hover triggers subnav) if device's primary input is not touch.
		initDesktopMenu();
	}
	initResizeOnScroll();
	initMobileMenu();
	initSearch();
}

/**
 * Scroll watch.
 *
 * Shrink nav based on scroll direction.
 * Use full size if scrollTop = 0.
 */
function resizeOnScroll() {
	// console.log('resizeOnScroll()');

	let scrollTop = $window.scrollTop();
	// console.log("scrollTop: "+scrollTop);
	
	// Full size at page top.
	// .mini/.scrolling anywhere else after clearing $header_height_desktop - $header_height_sticky (60)

	$header.toggleClass('scrolling', scrollTop > 60);
}

function initResizeOnScroll() {

	var scrollWatchHandler = function() {
		resizeOnScroll();
	};

	$window.on('scroll', scrollWatchHandler);
}

/**
 * Desktop nav.
 *
 *
 */
function initDesktopMenu() {
	// console.log("initDesktopMenu");

	// Set up hover actions on the top nav bar. We look for any menu
	// items that have a 'panel-id-*' class on them, which indicates
	// they have a full-width dropdown panel associated with them.
	// (THE LINEUP, SHOP)
	let $navItems;

	$navItems = $('.nav-bar__list .nav-bar__item');
	$.each($navItems, (index, el) => {
		let $el = $(el),
			$navbar = $('.nav-bar'),
			$headerInner = $('.site-header__inner'),
			$panelContainer = $el.find('.nav-bar__panel-container'),
			$panelCaret = $el.find('.nav-bar__panel-container-caret'),

			fadeinTimer = null,
			fadeoutTimer = null;

		$el.hoverIntent({
			over: function() {
				// console.log("HOVER");

				let 
					windowW = window.innerWidth,
					// headerX = parseInt($headerInner.offset().left),
					navbarX =  $navbar.position().left,
					navitemMargin = $(el).outerWidth(true) - $(el).outerWidth(),
					navitemX = $(el).position().left + navitemMargin,	// (margin-left)
					navitemW = $(el).width(),
					elX = $(el).position().left,
					delX = windowW/2 - (navbarX + navitemX),
					caretX = navbarX + navitemX + navitemW/2;

				// If .mega-nav, set x position of subnav panel to compensate for parent position.
				if ($panelContainer.hasClass('mega-nav')) {
					$panelContainer.css({left:delX});
					$panelCaret.css('position','absolute');
					$panelCaret.css({left:caretX});
				}

				// Set subnav panel display: block.
				$panelContainer.css('display','block');

				// Fade in subnav panel.
				// Delay added to preserve css transition. With no delay, opacity cuts from 0 to 1 w/o fade.
				fadeinTimer = setTimeout(() => {
					$panelContainer.addClass('is-active');
				}, 20);
			},
			out: function() {
				// console.log("HOVER OUT");

				// Fade out subnav panel.
				$panelContainer.removeClass('is-active');

				// Delay display:none until after fadeout completes (* _elements.scss).
				fadeinTimer = setTimeout(() => {
					$panelContainer.css('display','none');
				}, 300);

			},
			timeout: 200
		});
	});

	// Wire up subnav clicks to close the mobile nav.
	let $desktopSubnavLinks = $('a.nav-bar__panel-link');
	$desktopSubnavLinks.on("click", function() {
		let
			$panelContainer = $(this).parents('.nav-bar__panel-container'),
			fadeinTimer = null;
		$panelContainer.removeClass('is-active');
		fadeinTimer = setTimeout(() => {
			$panelContainer.css('display','none');
		}, 300);
	});
	
	// let 
	// 	$searchToggle = $('.util-nav-bar__link.search'),
	// 	$searchPanel = $('.search-panel'),
	// 	$searchClose = $('.search-panel .close-x');

	// $searchToggle.click(function(evt) {
	// 	console.log("SEARCH!");
	// 	evt.preventDefault();
	// 	$searchToggle.toggleClass('is-active');
	// 	if ($searchToggle.hasClass('is-active')) {
	// 		$searchPanel.slideDown('fast');
	// 		$('.search-field').focus();
	// 	} else {
	// 		$searchPanel.slideUp('fast');
	// 	}
	// });	
	// $searchClose.click(function(evt) {
	// 	console.log("CLOSE SEARCH!");
	// 	evt.preventDefault();
	// 	$searchToggle.toggleClass('is-active');
	// 	if (!$searchToggle.hasClass('is-active')) {
	// 		$searchPanel.slideUp('fast');
	// 	}
	// });

}

function initSearch() {
	console.log('HEADER: initSearch()');
	let 
		$searchToggle = $('.nav-bar__link.search, .nav-bar-mobile__link.search'),
		$searchPanel = $('.search-panel'),
		$searchOverlay = $('.search-panel__overlay'),
		$searchClose = $('.search-panel .close-x, .search-panel__overlay');

	$searchToggle.on('click', function(evt) {
		// $searchToggle.click(function(evt) {
		console.log("SEARCH!");
		evt.preventDefault();
		$searchToggle.toggleClass('is-active');
		if ($searchToggle.hasClass('is-active')) {
			$('html').addClass('lity-active');
			$searchOverlay.fadeIn('fast');
			$searchPanel.slideDown('fast');
			$('.search-field').trigger('focus');
		} else {
			$('html').removeClass('lity-active');
			$searchOverlay.fadeOut('fast');
			$searchPanel.slideUp('fast');
			setTimeout(function() { 
				$('html').removeClass('lity-active');
			}, 200);
		}
	});	

	$searchClose.on('click', function(evt) {
		console.log("CLOSE SEARCH!");
		evt.preventDefault();
		$searchToggle.toggleClass('is-active');
		if (!$searchToggle.hasClass('is-active')) {
			$searchOverlay.fadeOut('fast');
			$searchPanel.slideUp('fast');
			setTimeout(function() { 
				$('html').removeClass('lity-active');
			}, 200);
		}
	});
}

/**
 * Mobile nav.
 *
 *
 */
function initMobileMenu() {
	// console.log("initMobileMenu()");
	// Set up a listener on the burger menu
	let $burger = $header.find('.site-header__menu-icon-link'),
		$mobileNav = $('.nav-bar-mobile'),
		$closex = $('.nav-bar-mobile .close-x');

	$burger.click((event) => {
		event.preventDefault();
		$(event.target).toggleClass('js-close');    // Trigger 'close' version of icon
		$('html').toggleClass('no-scroll');         // Prevent scrolling on page content
		$header.toggleClass('js-force-dropshadow'); // Ensure dropshadow is visible, in case user is still at page top
		$header.toggleClass('js-mobile-nav-open');	// Selector for any descendents that vary when mobile nav is open
		$mobileNav.toggleClass('js-is-open');
	});

	$closex.click((event) => {
		event.preventDefault();
		// console.log("CLOSE");
		$(event.target).toggleClass('js-close');    // Trigger 'close' version of icon
		$('html').toggleClass('no-scroll');         // Prevent scrolling on page content
		$header.toggleClass('js-force-dropshadow'); // Ensure dropshadow is visible, in case user is still at page top
		$header.toggleClass('js-mobile-nav-open');	// Selector for any descendents that vary when mobile nav is open
		$mobileNav.toggleClass('js-is-open');
	});

	// // Wire up our header elements for opening/closing
	// let $headerButtons = $('.menu-header:not(.menu-header-always-open)');
	// $headerButtons.click((event) => {
	// 	let $navItem = $(event.currentTarget);
	// 	// Close any items that are NOT the currently clicked item
	// 	$.each($headerButtons, (index, item) => {
	// 		let $otherHeaderButton = $(item);
	// 		if ($otherHeaderButton[0] != $navItem[0]) {
	// 			$otherHeaderButton.find('.nav-bar-mobile__panel').slideUp();
	// 			$otherHeaderButton.removeClass('js-is-open');
	// 		}
	// 	});
		
	// 	// Now toggle the item that was clicked
	// 	$navItem.toggleClass('js-is-open');
	// 	$navItem.find('.nav-bar-mobile__panel').slideToggle();
	// });

	// // Wire up subnav clicks to close the mobile nav.
	// let $mobileSubnavLinks = $('.nav-bar-mobile__panel a');
	// $mobileSubnavLinks.click((event) => {
	// 	$burger.toggleClass('js-close');    // Trigger 'close' version of burger/close icon
	// 	$('html').toggleClass('no-scroll');         // Prevent scrolling on page content
	// 	$header.toggleClass('js-force-dropshadow'); // Ensure dropshadow is visible, in case user is still at page top
	// 	$header.toggleClass('js-mobile-nav-open');	// Selector for any descendents that vary when mobile nav is open
	// 	$mobileNav.toggleClass('js-is-open');
	// });

	// Wire up nav clicks to close the mobile nav.
	let $mobileNavLinks = $('a.nav-bar-mobile__link');
	$mobileNavLinks.click((event) => {
		$burger.toggleClass('js-close');    		// Trigger 'close' version of burger/close icon
		$('html').toggleClass('no-scroll');         // Prevent scrolling on page content
		$header.toggleClass('js-force-dropshadow'); // Ensure dropshadow is visible, in case user is still at page top
		$header.toggleClass('js-mobile-nav-open');	// Selector for any descendents that vary when mobile nav is open
		$mobileNav.toggleClass('js-is-open');
	});
}

exports.init = function ($el) {
	// console.log("header.js init");
	$header = $el;

    initHeader();
};